"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processExpressionTokensToken = exports.processVariablePlaceholderToken = exports.processExpressionPlaceholderToken = exports.processInvalidToken = exports.processFunctionToken = exports.processVariableToken = exports.processTokens = exports.tokenExpressionProcessors = exports.textExpressionProcessors = exports.expressionProcessors = void 0;
const expressions_1 = __importDefault(require("../lexers/expressions"));
const types_1 = require("./types");
exports.expressionProcessors = {
    [types_1.TokenType.VARIABLE]: processVariableToken,
    [types_1.TokenType.FUNCTION]: processFunctionToken,
    [types_1.TokenType.INVALID]: processInvalidToken,
    [types_1.TokenType.UNKNOWN]: processInvalidToken,
};
exports.textExpressionProcessors = {
    [types_1.TokenType.PLACEHOLDER]: processExpressionPlaceholderToken,
};
exports.tokenExpressionProcessors = {
    [types_1.TokenType.PLACEHOLDER]: processVariablePlaceholderToken,
};
function processTokens(tokens, processors) {
    let fnDependencies = [];
    let dependencies = [];
    const errors = [];
    const processedTokens = [];
    for (const token of tokens) {
        const processed = processToken(token, processors);
        errors.push(...processed.errors);
        dependencies = [...dependencies, ...processed.dependencies];
        fnDependencies = [...fnDependencies, ...processed.fnDependencies];
        processedTokens.push(processed);
    }
    return {
        tokens: processedTokens,
        dependencies: [...new Set(dependencies)],
        fnDependencies: [...new Set(fnDependencies)],
        errors,
    };
}
exports.processTokens = processTokens;
function processToken(token, processors) {
    var _a, _b;
    return (_b = (_a = processors[token.type]) === null || _a === void 0 ? void 0 : _a.call(processors, token)) !== null && _b !== void 0 ? _b : Object.assign(Object.assign({}, token), { dependencies: [], fnDependencies: [], errors: [] });
}
function getBaseToken(type, value) {
    return {
        type,
        value,
        dependencies: [],
        fnDependencies: [],
        errors: [],
    };
}
// Placeholders are of the form §subExpression§ or ${subExpression}
function stripDelimiters(expression) {
    return expression.slice(expression[0] === '§' ? 1 : 2, -1);
}
function processVariableToken(token) {
    const props = token.value.split('.').map((p) => `['${p}']`);
    return Object.assign(Object.assign({}, getBaseToken(token.type, `state${props.join('')}`)), { dependencies: [token.value] });
}
exports.processVariableToken = processVariableToken;
function processFunctionToken(token) {
    const fnName = token.value.slice(0, -1); // Remove trailing '('
    return Object.assign(Object.assign({}, getBaseToken(token.type, `state._fns.${token.value}`)), { fnDependencies: [fnName] });
}
exports.processFunctionToken = processFunctionToken;
function processInvalidToken(token) {
    return Object.assign(Object.assign({}, getBaseToken(token.type, token.value)), { errors: [{ type: 'invalidToken', items: [token.value] }] });
}
exports.processInvalidToken = processInvalidToken;
function processExpressionPlaceholderToken(token) {
    const subExpression = stripDelimiters(token.value);
    const subTokens = (0, expressions_1.default)(subExpression);
    const processed = processTokens(subTokens, exports.expressionProcessors);
    return Object.assign(Object.assign({}, getBaseToken(token.type, `\${${processed.tokens.map((t) => t.value).join('')}}`)), { dependencies: [...processed.dependencies], fnDependencies: [...processed.fnDependencies], errors: processed.errors });
}
exports.processExpressionPlaceholderToken = processExpressionPlaceholderToken;
function processVariablePlaceholderToken(token) {
    const subExpression = stripDelimiters(token.value);
    const subTokens = (0, expressions_1.default)(subExpression);
    if (subTokens.length !== 1 || subTokens[0].type !== types_1.TokenType.VARIABLE) {
        return Object.assign(Object.assign({}, getBaseToken(token.type, '')), { errors: [{ type: 'invalidPlaceholder', items: [token.value] }] });
    }
    const processed = processTokens(subTokens, exports.expressionProcessors);
    return Object.assign(Object.assign({}, getBaseToken(token.type, processed.tokens[0].value)), { placeholder: subTokens[0].value, dependencies: [...processed.dependencies], errors: processed.errors });
}
exports.processVariablePlaceholderToken = processVariablePlaceholderToken;
function processExpressionTokensToken(token) {
    const processed = processTokens(token.value, exports.expressionProcessors);
    return Object.assign({}, getBaseToken(token.type, token.value));
}
exports.processExpressionTokensToken = processExpressionTokensToken;
